import imageWithCaption from "../objects/imageWithCaption";
import { multilingualArrayBlockContent } from "../base";
import diningAreaCategory from "./diningAreaCategory";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "shipDiningArea",
  title: "Ship Dining Area",
  type: "object",
  preview: {
    select: {
      title: "category.name",
      imageUrl: "images.0.asset.url"
    },
    prepare({ title }) {
      return { title: multilingualStringPreview(title) };
    }
  },
  groups: [
    { name: "asCard", title: "Render as Card" },
    {
      name: "seo",
      title: "SEO, Routing & Tracking"
    }
  ],
  fields: [
    {
      name: "category",
      title: "Category",
      type: "reference",
      to: [{ type: diningAreaCategory.name }],
      validation: (Rule) => Rule.required()
    },
    {
      name: "description",
      title: "Description",
      type: multilingualArrayBlockContent.name,
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "images",
      title: "Images",
      type: "array",
      of: [{ type: imageWithCaption.name }]
    },
    {
      name: "card",
      title: "Render as Card",
      type: "asCard",
      group: "asCard"
    }
  ]
});
